export default __webpack_public_path__ + "static/media/module-ph.67b8f97e.png";